import React, { useState, useEffect } from "react";
import './App.css';
import styled from 'styled-components';
import { Desktop, Mobile } from "./components/SpotifyEmbed";
import Header from './components/Header';
import Footer from './components/Footer';
import Landing from "./components/Landing";
import ArticleCardMobile from './components/ArticleCardMobile'
import ArticleGrid from './components/AritcleGrid';
import Card from './components/Card';
import noise from './images/noiseLayer.png';

import jazz from './images/jazz.gif';
import contemporary from './images/contemporary.gif';
import other from './images/other.gif';
import related from './images/related.gif';
import Gif from './components/Gif';


function App() {
  const [ data, setData ] = useState(null);
  
  useEffect(() => {
		fetch("https://kerckhoff.dailybruin.com/api/packages/flatpages/interactive.2022.grammys")
		.then(res => res.json())
		.then(res => setData(res.data['article.aml']))
  }, [])

  data && console.log(data);
  return data && (
    <div className="App">
      <Landing />
      {data && <Gif file={jazz} credit={data.jazz[0].credit} />}
      {data && <ArticleGrid articles={data.jazz} section={"jazz"}/>} 
      {data && <Gif file={contemporary} credit={data.contemporary[0].credit} />}
      {data && <ArticleGrid articles={data.contemporary}  section={"contemporary"}/>} 
      {data && <Gif file={other} credit={data.other[0].credit} />}
      {data && <ArticleGrid articles={data.other} section={"other"}/>} 
      {data && <Gif file={related} credit={data.related[0].credit} />}
      {data && <ArticleGrid articles={data.related} section={"related"}/>} 
      <Footer />
    </div>
  );

}

export default App;
